export const LOCAL_DIRECTORY_HOST = "directory.localhost";
export const PROD_DIRECTORY_HOST = "directory.atw.net";
export const PROD_DIRECTORY_PAGES_PREVIEW = "atw-directory.pages.dev";

export function isAtwDirectoryPublicHost(hostname: string): boolean {
  const h = hostname.split(":")[0].toLowerCase();
  return h === PROD_DIRECTORY_HOST || h === LOCAL_DIRECTORY_HOST;
}

export function isAtwDirectoryPagesPreviewHost(hostname: string): boolean {
  const h = hostname.split(":")[0].toLowerCase();
  return h === PROD_DIRECTORY_PAGES_PREVIEW;
}

export function atwDirectoryAppOrigin(): string {
  if (typeof window !== "undefined") {
    return window.location.origin.replace(/\/$/, "");
  }
  return `https://${PROD_DIRECTORY_HOST}`;
}

export function atwDirectoryAppUrl(path = "/"): string {
  const normalized = !path || path === "/" ? "/" : path.startsWith("/") ? path : `/${path}`;
  return `${atwDirectoryAppOrigin()}${normalized}`;
}

/** SPA routes use short paths on the Directory host. */
export function directoryHref(shortPath: string): string {
  const normalized =
    !shortPath || shortPath === "/" ? "/" : shortPath.startsWith("/") ? shortPath : `/${shortPath}`;
  return normalized;
}
